// stores/theme.ts
import constants from '@shared/constants'
import localStorageService from '@core/persistence/localStorage/localStorageService'
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // Initialize from localStorage or default to false
  const isDarkMode = ref(localStorageService.getItem(constants.LOCAL_STORAGE_KEYS.THEME) === 'dark')

  // Watch for changes to persist to localStorage
  watch(isDarkMode, (val) => {
    localStorageService.setItem(constants.LOCAL_STORAGE_KEYS.THEME, val ? 'dark' : 'light')
  })

  function toggleTheme() {
    isDarkMode.value = !isDarkMode.value
  }

  return { isDarkMode, toggleTheme }
})
